define(['jquery', 'components/modal', 'baremetrics-calendar', 'moment', 'core/urls', 'components/dropdown', 'core/iterate', 'core/utilities'],
    function ($, modal, Calendar, moment, urls, DD, iterate, utilities) {
        var nodes = {
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    // document.querySelector(".nps-s1-setup-campaign"),
                    // document.querySelector(".navigation-main"),
                    // document.querySelector(".navigation-top")
                ]
            },
            ruleList: document.querySelector(".nps-rules-list_js"),
            pauseToggle: document.querySelector("#pause_toggle"),
            pauseText: document.querySelector(".hint-resume"),
            formLine: document.querySelector(".form-line"),
            form: document.querySelector(".form"),
            closeModalClass: ".modal-close-submit_js",
            modalContent: document.querySelector('.modal-template-welcome_js'),
            submit: document.querySelector('.nps-campaign-submit_js'),
            pauseState: document.querySelector('.pause-state_js')
        };

        function msieversion() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {
                return true;
            } else  // If another browser, return 0
            {
                return false;
            }

            return false;
        }

        var closeModal = null;

        function onCloseModal() {
            createdModal.close();
        }

        var createdModal = modal.create(nodes.modal, function (el) {});
        let modalTemplate = document.querySelector(".modal-template-leave_js")
        let hrefs = document.querySelectorAll("a[href]");

        let hrefsToIgnore = [
            urls['nps:campaign'](), 
            urls['nps:configure-email'](), 
            urls['nps:configure-feedback'](), 
            urls['nps:survey']()
        ] 

        function exitWarningGeneric() {
            iterate(hrefs, function (node) {
                node.addEventListener("click", event => {
                    utilities.confirmPageExit(event, createdModal, modalTemplate, null, hrefsToIgnore);
                });
            });
        }

        return {
            init: function () {

                DD(document.querySelector(".starting_on_js"), (val) => {});

                if (msieversion()) {
                    [...document.querySelectorAll(".down-image_js")].forEach((n) => {
                        n.style.display = "none";
                    });
                }

                let scheduleDate = document.querySelector("[name=\"schedule_date\"]").value;

                function initDatePicker(cb) {

                    if (scheduleDate === "None") {
                        scheduleDate = false;
                    }

                    return new Calendar({
                        presets: [// This calendar requires presets, but we don't need it.
                            {
                              label: 'fake',
                              start: null,
                              end: null
                            }
                        ],
                        preset_label: 'fake',
                        element: $(".daterange--single"),
                        current_date: scheduleDate ? scheduleDate : moment().add(1, 'days'),
                        earliest_date: moment(),
                        required: true,
                        format: {
                            input: 'MMM D, YYYY'
                        },
                        days_array: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                        callback: function () {
                            var start = moment(this.current_date).format('YYYY-MM-DD');
                            cb(start);
                        }
                    });

                }

                var hiddenDP = document.querySelector(".datepicker_hidden_input");

                if(scheduleDate === 'None' || !scheduleDate) {
                    // there is no schedule data returned from the backend, so we'll set the date as tomorrow
                    hiddenDP.value = moment().add(1, 'days').format("YYYY-MM-DD");
                } else {
                    // use the saved date
                    hiddenDP.value = scheduleDate;
                }

                var datePicker = initDatePicker(function (value) {

                    hiddenDP.value = value;

                });

                document.addEventListener("click", (e) => {
                    let target = e.target;
                    let targetId = target.getAttribute("id");
                    let count = 0;
                    let inside = false;
                    while (targetId !== "datepicker" && count < 5) {
                        if (!target) {
                            break;
                        }
                        target = target.parentNode;
                        if (!target.getAttribute) {
                            break;
                        }
                        targetId = target.getAttribute("id");
                        if (targetId === "datepicker") {
                            inside = true;
                        }
                    }
                    if (!inside) {
                        datePicker.calendarClose('force');
                        if (datePicker.presetIsOpen)
                            datePicker.presetToggle();
                    }

                });

                let drDate = document.querySelector(".dr-date");

                drDate.addEventListener("keydown", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                });

                let resendToggle = document.querySelector("#id_is_resend_active");
                let resendFrequency = document.querySelector(".resend-frequency .custom-select");

                resendToggle.checked ? resendFrequency.classList.remove("disabled") : resendFrequency.classList.add("disabled");

                resendToggle.addEventListener("change", (event) => {
                    event.target.checked ? resendFrequency.classList.remove("disabled") : resendFrequency.classList.add("disabled");
                })

                var button = document.querySelector('.nps-campaign-submit_js');
                var campaignNameInput = document.querySelector('.nps-campaign-input_js');

                exitWarningGeneric();

                nodes.pauseToggle.addEventListener("change", ({target}) => {
                    let labelLeft = document.querySelector(".slide-toggle-wrapper .toggle-label.left");
                    let labelRight = document.querySelector(".slide-toggle-wrapper .toggle-label.right");
                    let pausedValue;

                    if(target.checked) {
                        labelLeft.classList.add("active");
                        labelRight.classList.remove("active");
                        pausedValue = true;
                    } else {
                        labelLeft.classList.remove("active");
                        labelRight.classList.add("active");
                        pausedValue = false;
                    }

                    setRule({
                        paused: pausedValue
                    }).then();
                })

                campaignNameInput.addEventListener("keydown", (event) => {
                    var tabKey = 9;
                    if(event.keyCode == tabKey && paused) {
                        event.preventDefault();
                        button.focus();
                    }
                })

                function setRule(data) {
                    return new Promise((res, rej) => {

                        var XHR = new XMLHttpRequest();

                        // Set up our request
                        XHR.open('POST', urls['nps:pause']());
                        XHR.setRequestHeader("X-CSRFToken", document.querySelector('input[name="csrfmiddlewaretoken"]').value) 
                        // Add the required HTTP header for form data POST requests
                        XHR.setRequestHeader('Content-Type', 'application/json');

                        // Finally, send our data.
                        XHR.send(JSON.stringify(data));

                    })
                }

                nodes.ruleList = document.querySelector('.nps-rules-list_js');
                let repeatDropdown = DD(document.querySelector(".repeat_js"), (val) => {});
                repeatDropdown.chooseOption("6")
                DD(document.querySelector(".language_js"), (val) => {});
                DD(document.querySelector(".auto-resend_js"), (val) => {});
                DD(document.querySelector(".timezone_js"), (val) => {});

                let errorMessage = document.createElement("div");
                errorMessage.innerText = "This field is required.";
                errorMessage.classList.add("disabled");
                errorMessage.classList.add("error-required-message");
                campaignNameInput.parentNode.appendChild(errorMessage);

                nodes.submit.addEventListener("click", (e) => {

                    document.querySelectorAll(".page-error-wrap").forEach(node => {
                        node.classList.remove("page-error-wrap");
                    })

                    document.querySelectorAll(".page-error").forEach(node => {
                        node.remove();
                    })

                    nodes.pauseToggle.value = nodes.pauseToggle.checked ? 1 : 0;

                    if (campaignNameInput.value.trim().length < 1) {
                        e.preventDefault();
                        campaignNameInput.classList.add("danger");
                        campaignNameInput.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                        errorMessage.classList.remove('disabled')
                    }
                });

                button.classList.remove('disabled');

                if (nodes.modalContent && !campaignNameInput.value.trim().length) {

                    var content = nodes.modalContent;
                    var title = content.getAttribute("data-title");
                    var className = content.getAttribute("data-class");

                    createdModal.open({

                        //set a wrap class for a modal
                        class: className,
                        //set content for a modal
                        content: content.innerHTML,
                        //set title for a modal
                        title: title

                    }, function (el) {

                        closeModal = el.querySelector(nodes.closeModalClass);
                        closeModal.addEventListener('click', onCloseModal);

                    })
                }


            }
        }
    }
);